import React, { Fragment } from "react";
import MainHeader from "../../commons/mainheader/mainheader";
import TopHeader from "../../commons/topheader/topheader";
import "./header.css";
const Header = () => {
  return (
    <Fragment>
      <div>
        <TopHeader />
        <MainHeader />
      </div>
    </Fragment>
  );
};

export default Header;
